<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600px">
    <v-card>
      <v-card-title class="pa-0">
        <v-col class="text-end py-0 px-0" cols="12">
          <v-btn class="pa-0" icon dark @click="close">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0" cols="12">
          <h1 style="font-size:24px">Protocolo</h1>
          <span>
            <button @click="close" class="button-histor pa-0">
              <v-icon class="py-0 px-1" color="primary" x-small>far fa-eye-slash</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico</b>
            </button>
            <p style="font-size:14px;line-height:18px" class="mb-2">
              Caso necessário, <br> edite o retorno da operadora.
            </p>
          </span>
        </v-col>
      </v-card-title>
      <v-card-text class="px-5 pt-0 pb-1">
        <v-data-table dense :headers="headers" :items="list" hide-default-footer>
          <template v-slot:item="props">
            <tr>
              <td class="text-center pa-2">{{ props.item.dt_alteracao | formatDate }}</td>
              <td class="text-center pa-2">{{ props.item.numero }}</td>
              <td class="text-center pa-2">{{ props.item.dt_protocolo | formatDate }}</td>
              <td class="text-left pa-2">{{ getStatus(props.item) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          height="30px"
          small
          depressed
          @click="close"
        > Voltar </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  methods: {
    getStatus(item){
      if(item.status != 3){
        return this.statusList[item.status]
      } else {
        return item.critica !=null? this.statusList[1] : this.statusList[item.status]
      }
    }
  },
  props: {
    dialog: Boolean,
    close: Function,
    list: Array,
    statusList: Object,
    headers: Array,
    isLoteComplementar: Boolean,
    complementar: Boolean
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
</style>